import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	summaryCellError: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.summary-cell-error',
		defaultMessage: 'Something went wrong loading details for this pull request',
		description:
			'An error message displayed inside a table cell when there are issues loading the title of a pull request.',
	},
	lastUpdatedCellError: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.last-updated-cell-error',
		defaultMessage: 'Unknown',
		description:
			'An error message displayed inside a table cell when there are issues loading the last updated time for a pull request.',
	},
	headerSummary: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.header-summary',
		defaultMessage: 'Summary',
		description:
			'Header for the Summary column on the pull request table. Column shows a summary of the pull request',
	},
	headerStatus: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.header-status',
		defaultMessage: 'Status',
		description:
			'Header for the Status column on the pull request table. Column shows the status of pull requests',
	},
	headerReviewers: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.header-reviewers',
		defaultMessage: 'Reviewers',
		description:
			'Header for the Reviewers column on the pull request table. Column shows the assigned reviewers of the pull requests',
	},
	headerComments: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.header-comments',
		defaultMessage: 'Comments',
		description:
			'Header for the Comments column on the pull request table. Column shows the count of comments on the pull requests',
	},
	headerUpdated: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.header-updated',
		defaultMessage: 'Updated',
		description:
			'Header for the Updated column on the pull request table. Column shows the last updated date of the pull requests',
	},
});
